import { amplitudeLib } from 'freedom-shared';
import { airflow } from '@aviata/platform-client';
import { providerClassLib } from 'shared';

import { extractAnalyticsDataLib } from '../analytics-data-extraction';
import type { BookingSuccessInfo } from '../analytics';
import { getSearchModeFromQuery, getMainPageVariant } from './main-page';
import type { QuickBookingFlow } from './quick-booking';

export const bookingSuccess = (
  info: BookingSuccessInfo & { flow?: QuickBookingFlow },
) => {
  let searchType: string | undefined;
  if (info.searchQuery) {
    const searchParams = airflow.utils.parseQuery(info.searchQuery);
    searchType = getSearchModeFromQuery(searchParams);
  }

  amplitudeLib.logEvent('avfree_success_booking', {
    order_number: info.orderNumber,
    products: extractAnalyticsDataLib.products(
      info.products,
      info.medicalInsurance,
      info.roaming,
    ),
    package: extractAnalyticsDataLib.package(info.packageInfo, info.products),
    seat_map: extractAnalyticsDataLib.seatsCodes(info.seatMap),
    ancillary_baggage_count: extractAnalyticsDataLib.baggageCount(info.baggage),
    source: info.source,
    connect_type: extractAnalyticsDataLib.getConnectType(info.connectType),
    travel_type: info.isDomestic ? 'D' : 'I',
    search_mode: searchType,
    is_charter: providerClassLib.isFunSun(info.providerClass ?? ''),
    has_airline_bonus_cards: info.airlineBonusCards.length > 0,
    airline_bonus_cards: info.airlineBonusCards,
    flow: info.flow ?? 'classic',
    main_page_variant: getMainPageVariant(),
  });
};

export const bookingError = (error: string) =>
  amplitudeLib.logEvent('avfree_error_booking', {
    error,
    main_page_variant: getMainPageVariant(),
  });

export const productsPageOpen = (
  providerClass?: string,
  flow: QuickBookingFlow = 'classic',
) =>
  amplitudeLib.logEvent('avfree_products_page_open', {
    is_charter: providerClassLib.isFunSun(providerClass ?? ''),
    flow,
    main_page_variant: getMainPageVariant(),
  });

type PriceChangeGuardParams = {
  provider_class: string;
  flow: QuickBookingFlow;
};

export const priceChangeGuardShown = (params: PriceChangeGuardParams) =>
  amplitudeLib.logEvent('avfree_price_change_guard_shown', params);

export const priceChangeGuardContinue = (params: PriceChangeGuardParams) =>
  amplitudeLib.logEvent('avfree_price_change_guard_continue', params);

export const priceChangeGuardCancel = (params: PriceChangeGuardParams) =>
  amplitudeLib.logEvent('avfree_price_change_guard_cancel', params);
